










import { Vue, Component, Prop } from 'vue-property-decorator';
import UiProgressBarComponent from '@/app/shared/components/ui/ui-progress-bar-component.vue';

@Component({
  components: {
    UiProgressBarComponent
  }
})
export default class ScenarioResultComponent extends Vue {
  @Prop({
    required: true,
  })
  public scenarioResults: { [title: string]: number };
}
